import * as Sentry from '@sentry/browser';

export function safeLog(...args: any[]) {
	console.log(
		...args.map((arg) =>
			typeof arg === 'object' && !(arg instanceof Error)
				? JSON.stringify(arg)
				: arg,
		),
	);
}

export function safeWarn(...args: any[]) {
	console.warn(
		...args.map((arg) =>
			typeof arg === 'object' && !(arg instanceof Error)
				? JSON.stringify(arg)
				: arg,
		),
	);
}

export function safeError(...args: any[]) {
	console.error(
		...args.map((arg) =>
			typeof arg === 'object' && !(arg instanceof Error)
				? JSON.stringify(arg)
				: arg,
		),
	);
}

export function reportSentryError(context: string, error: unknown) {
	if (error instanceof Error) {
		Sentry.captureException(error);
	} else if (typeof error === 'object') {
		Sentry.captureException(new Error(`${context}: ${JSON.stringify(error)}`));
	} else {
		Sentry.captureException(new Error(`${context}: ${String(error)}`));
	}
}
